import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BankStatementTransaction } from "@/types/bank-statement";

interface ViewTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: BankStatementTransaction | null;
}

const formatBRL = (value: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

export function ViewTransactionModal({ isOpen, onClose, transaction }: ViewTransactionModalProps) {
  if (!transaction) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px] bg-[#15203c] border-gray-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Detalhes da Operação</DialogTitle>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-400">Data do Pagamento</p>
              <p className="font-medium">{transaction.paymentDate}</p>
            </div>
            <div>
              <p className="text-sm text-gray-400">Valor</p>
              <p className="font-medium text-[#13d480]">{formatBRL(transaction.amount)}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-gray-400">Descrição</p>
              <p className="font-medium">{transaction.description || "-"}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-gray-400">Credor</p>
              <p className="font-medium">{transaction.creditorName || "N/A"}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-gray-400">Categoria (Classificação)</p>
              <p className="font-medium">{transaction.category || "Não classificado"}</p>
            </div>
            <div>
              <p className="text-sm text-gray-400">Tipo de Transação</p>
              <p className="font-medium">{transaction.transactionType === "CREDIT" ? "Crédito (C)" : "Débito (D)"}</p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={onClose} variant="outline" className="border-gray-600 text-white hover:bg-gray-700">
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
